export default "__VITE_ASSET__BAhCVbuE__"